
function CrownSVG() {
  return (
    <svg width="36" height="26" viewBox="0 0 36 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.916016 7.16665L6.04102 25.9583H29.9577L35.0827 7.16665L24.8248 10.5833L17.9993 0.333313L11.1921 10.5833L0.916016 7.16665Z" fill="#FAB818"/>
    </svg>
  )
}

function CrownMiniOutlineSVG() {
  return (
    <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.7733 5.76876L12.1951 6.37871L12.9012 6.15222L16.5297 4.98844L14.5439 12H3.45612L1.47001 4.98733L5.10881 6.15238L5.8156 6.37867L6.23694 5.76774L9.00109 1.75978L11.7733 5.76876Z" stroke="black" strokeWidth="2"/>
    </svg>
  )
}


export { 
  CrownSVG,
  CrownMiniOutlineSVG
}